var module = angular.module('octopusApp.tenants');

module.controller('TenantLogoController', function($scope, $location, $stateParams, $state, tenantState, busy, octopusRepository, octoUploader, octopusClient) {
    var vm = this;
    var tenantId = tenantState.tenantId;
    var octoUpload = octoUploader.create($scope);

    vm.isUploading = busy.create();
    vm.octoUpload = octoUpload;
    vm.beginReset = beginReset;
    vm.beginUpload = beginUpload;
    vm.cancel = cancel;

    function cancel() {
        octoUpload.cancel();

        var form = $("#logoUpload")[0];
        if (form) {
            form.reset();
        }
    }

    function init() {
        tenantState.isLoading.promise(tenantState.load().then(onTenantLoaded));
    }

    function beginUpload() {
        var url = octopusClient.resolve(vm.tenant.Links['Logo']);
        vm.isUploading.promise(octoUpload.begin(url).then(function () {
            $state.reload();
            //$location.path('/tenants/' + vm.tenant.Id);
        }));
    }

    function beginReset() {
        vm.isUploading.promise(octopusClient.put(vm.tenant.Links['Logo'], null).then(function () {
            $state.reload();
            //$location.path('/tenants/' + vm.tenant.Id);
        }));
    }

    function onTenantLoaded(tenant) {
        vm.tenant = tenant;
    }

    init();
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/controllers/tenant_logo_controller.js
// module id = 628
// module chunks = 1